(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-announcement]').forEach((bar) => {
    const close = bar.querySelector('[data-announcement-close]');
    if (!close) return;

    close.addEventListener('click', () => {
      bar.hidden = true;
      try {
        localStorage.setItem(bar.dataset.storageKey, 'dismissed');
      } catch (error) {
        /* Dismissal simply will not persist if storage is unavailable. */
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class ShopMenu {
    constructor(header) {
      this.toggle = header.querySelector('.shop-header__menu-toggle');
      this.panel = document.getElementById('shop-menu');

      if (!this.toggle || !this.panel) return;

      this.toggle.addEventListener('click', () => this.setOpen(this.panel.hidden));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.panel.hidden) this.setOpen(false);
      });
    }

    setOpen(open) {
      this.panel.hidden = !open;
      this.toggle.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }
  }

  document.querySelectorAll('.shop-header').forEach((header) => new ShopMenu(header));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductVariants {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('form');
      this.idInput = root.querySelector('[data-variant-id]');
      this.skuNode = root.querySelector('[data-product-sku]');
      this.specNode = root.querySelector('[data-product-spec]');

      /*
       * Plural because the sticky bar carries a second price and a second
       * add button. They are the same controls rendered twice, not a
       * separate feature — so every one of them is updated from here and
       * none can fall out of step with the panel.
       */
      this.priceNodes = [...root.querySelectorAll('[data-product-price]')];
      this.submits = [...root.querySelectorAll('[data-product-submit]')];
      this.submitTexts = [...root.querySelectorAll('[data-product-submit-text]')];

      const data = document.querySelector('[data-product-variants]');
      if (!data || !this.form) return;

      try {
        this.variants = JSON.parse(data.textContent);
      } catch (error) {
        return;
      }

      root.querySelectorAll('[data-option-input]').forEach((input) => {
        input.addEventListener('change', () => this.update());
      });

      /*
       * Mark the initial selection up front. The panel's own labels are
       * covered by a `:checked + label` rule in CSS, but the sticky bar's
       * labels are not siblings of the radios and cannot be — so without
       * this the bar opened with nothing marked as chosen until the first
       * interaction.
       */
      this.markSelected();

      this.watchScroll();
    }

    selectedOptions() {
      return [...this.root.querySelectorAll('[data-option-input]:checked')].map((i) => i.value);
    }

    /*
     * Marks the chosen value: names it beside the option, and sets an
     * explicit class on its label.
     *
     * The CSS also styles `:checked + label`, which is what works without
     * JS. The class is belt and braces — that sibling rule depends on the
     * browser invalidating the label when the input's checked state flips,
     * and the selected state is too important to rest on that alone.
     */
    markSelected() {
      this.root.querySelectorAll('[data-option-selected]').forEach((node) => {
        const position = node.dataset.optionSelected;
        const chosen = this.root.querySelector(`[name="option${position}"]:checked`);
        node.textContent = chosen ? chosen.value : '';
      });

      this.root.querySelectorAll('[data-option-input]').forEach((input) => {
        /*
         * querySelectorAll, not querySelector: each radio now has a label
         * in the panel and another in the sticky bar. Marking only the
         * first left the bar showing a stale selection after the image
         * rail scrolled.
         */
        this.root.querySelectorAll(`label[for="${input.id}"]`).forEach((label) => {
          label.classList.toggle('product__option-label--selected', input.checked);
        });
      });
    }

    update({ scrollToImage = true } = {}) {
      const chosen = this.selectedOptions();
      const variant = this.variants.find((candidate) =>
        candidate.options.every((option, index) => option === chosen[index])
      );

      if (!variant) {
        this.setUnavailable();
        return;
      }

      this.idInput.value = variant.id;
      this.markSelected();

      this.priceNodes.forEach((node) => {
        node.textContent = variant.price;
      });
      if (this.skuNode) this.skuNode.textContent = variant.sku || '';

      // The spec line hides itself when nothing is left to say.
      if (this.specNode) {
        const hasContent = [...this.specNode.querySelectorAll('span')].some(
          (span) => span.textContent.trim().length > 0
        );
        this.specNode.hidden = !hasContent;
      }

      this.submits.forEach((button) => {
        button.disabled = !variant.available;
      });
      this.submitTexts.forEach((node) => {
        node.textContent = variant.available
          ? this.root.dataset.addLabel
          : this.root.dataset.soldOutLabel;
      });

      if (scrollToImage) this.showVariantImage(variant);
    }

    /*
     * Bring the chosen variant's photograph into view.
     *
     * Two layouts, two axes: on a desktop the frames are a vertical column
     * and the page scrolls to one; on a phone they are a horizontal rail
     * and the rail scrolls sideways within itself. The phone case used to
     * return early, so picking a colourway there changed the label and
     * nothing else.
     */
    showVariantImage(variant) {
      if (!variant.imageId) return;

      const frame = this.root.querySelector(`[data-image-id="${variant.imageId}"]`);
      if (!frame) return;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const behavior = reduced ? 'auto' : 'smooth';

      /*
       * Scrolling the images also selects a variant, so a scroll started by
       * the picker would come straight back as a selection. Mute the sync
       * until the movement settles.
       */
      this.holdSync();

      if (window.matchMedia('(min-width: 750px)').matches) {
        const offset = parseInt(getComputedStyle(frame).scrollMarginTop, 10) || 0;
        if (Math.abs(frame.getBoundingClientRect().top - offset) < 4) return;
        frame.scrollIntoView({ behavior, block: 'start' });
        return;
      }

      /*
       * block: 'nearest' keeps the page where it is — without it the
       * browser also scrolls vertically and throws the picker off screen
       * at the moment of choosing.
       */
      frame.scrollIntoView({ behavior, block: 'nearest', inline: 'center' });
    }

    /*
     * The reverse binding: whichever photograph you have scrolled to selects
     * its variant.
     *
     * Two axes to cover — a vertical column on a desktop, a horizontal rail
     * on a phone — so rather than two observers this measures which frame
     * sits nearest the centre of whichever container is scrolling. Frames
     * belonging to no variant are skipped, so scrolling past a detail shot
     * leaves the choice alone.
     */
    watchScroll() {
      this.frames = [...this.root.querySelectorAll('[data-image-id]')];
      if (this.frames.length < 2) return;

      this.rail = this.root.querySelector('.product__media');
      let queued = false;

      const sync = () => {
        queued = false;
        if (this.syncHeld) return;

        const onePerScreen = window.matchMedia('(min-width: 750px)').matches;
        const box = onePerScreen
          ? { start: 0, end: window.innerHeight }
          : (({ left, right }) => ({ start: left, end: right }))(this.rail.getBoundingClientRect());
        const centre = (box.start + box.end) / 2;

        let nearest = null;
        let shortest = Infinity;
        this.frames.forEach((frame) => {
          const b = frame.getBoundingClientRect();
          const mid = onePerScreen ? (b.top + b.bottom) / 2 : (b.left + b.right) / 2;
          const distance = Math.abs(mid - centre);
          if (distance < shortest) {
            shortest = distance;
            nearest = frame;
          }
        });
        if (!nearest) return;

        const variant = this.variants.find(
          (candidate) => String(candidate.imageId) === nearest.dataset.imageId
        );
        if (!variant) return;
        if (String(this.idInput.value) === String(variant.id)) return;

        variant.options.forEach((value, index) => {
          const input = this.root.querySelector(
            `[name="option${index + 1}"][value="${CSS.escape(value)}"]`
          );
          if (input) input.checked = true;
        });

        this.update({ scrollToImage: false });
      };

      const request = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(sync);
      };

      window.addEventListener('scroll', request, { passive: true });
      if (this.rail) this.rail.addEventListener('scroll', request, { passive: true });

      /* The axis changes at the breakpoint, so re-read after a resize. */
      window.addEventListener('resize', request, { passive: true });
      sync();
    }

    /*
     * Mute the scroll sync until a programmatic scroll has finished.
     *
     * Released on `scrollend` where supported: a long smooth scroll outruns
     * any fixed timer, and releasing early lets the sync latch onto a frame
     * the movement is still travelling through. The timer is the fallback.
     */
    holdSync() {
      this.syncHeld = true;
      clearTimeout(this.syncTimer);

      const release = () => {
        this.syncHeld = false;
        clearTimeout(this.syncTimer);
        window.removeEventListener('scrollend', release);
        if (this.rail) this.rail.removeEventListener('scrollend', release);
      };

      if ('onscrollend' in window) {
        window.addEventListener('scrollend', release, { once: true });
        if (this.rail) this.rail.addEventListener('scrollend', release, { once: true });
      }

      this.syncTimer = setTimeout(release, 1600);
    }

    /*
     * Restored: an earlier edit of mine removed this while rewriting the
     * scroll logic. update() still called it, so choosing a combination
     * that maps to no variant threw instead of disabling the button.
     */
    setUnavailable() {
      this.submits.forEach((button) => {
        button.disabled = true;
      });
      this.submitTexts.forEach((node) => {
        node.textContent = this.root.dataset.unavailableLabel;
      });
    }

  }

  /*
   * Drives the sticky buy bar's three states from scroll position, without
   * listening to scroll.
   *
   * Everything here is presentation: which parts of the bar are on screen.
   * The bar's controls are wired to the panel through shared radio inputs
   * and a shared form, so none of the variant or cart logic is repeated in
   * this class — it decides visibility and nothing else.
   */
  class ProductStickyBar {
    constructor(root) {
      this.bar = root.querySelector('[data-product-bar]');
      if (!this.bar || typeof IntersectionObserver === 'undefined') return;

      this.root = root;
      this.buttonVisible = false;
      this.descriptionPassed = false;
      this.footerVisible = false;

      /*
       * The in-flow button. Plain threshold 0 and no root margin: the
       * literal question is whether it is on screen. While the bar is up it
       * covers the lowest ~130px, so the button first intersects behind the
       * bar — which immediately hides the bar and uncovers it. That settles
       * in one step and cannot oscillate, because hiding the bar does not
       * change whether the button intersects.
       */
      const inFlow = root.querySelector('.product__submit');
      if (inFlow) {
        this.watch(inFlow, (entry) => {
          this.buttonVisible = entry.isIntersecting;
        });
      }

      /*
       * The end of the description. isIntersecting alone cannot tell "not
       * yet reached" from "scrolled past" — both report false — so the sign
       * of the rect's top is what distinguishes them.
       */
      const end = root.querySelector('[data-description-end]');
      if (end) {
        this.watch(end, (entry) => {
          this.descriptionPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        });
      }

      const footer = document.querySelector('.shop-footer');
      if (footer) {
        this.watch(footer, (entry) => {
          this.footerVisible = entry.isIntersecting;
        });
      }

      /*
       * Publishes the bar's height to the page so the last element clears
       * it. A ResizeObserver rather than a measurement taken once: the bar
       * changes height when the variant row collapses, and this reports
       * every frame of that transition instead of a single stale number.
       */
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(() => this.publishHeight()).observe(this.bar);
      }

      this.render();
    }

    watch(target, onEntry) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(onEntry);
        this.render();
      });
      observer.observe(target);
    }

    publishHeight() {
      const visible = this.bar.classList.contains('is-visible');
      const height = visible ? this.bar.getBoundingClientRect().height : 0;
      this.root.style.setProperty('--product-bar-height', `${Math.round(height)}px`);
    }

    render() {
      // Order is the precedence: the footer wins, then the in-flow button.
      const visible = !this.footerVisible && !this.buttonVisible;

      this.bar.classList.toggle('is-visible', visible);
      this.bar.classList.toggle('is-compact', this.descriptionPassed);
      this.root.classList.toggle('product--bar-visible', visible);

      this.publishHeight();
    }
  }

  /*
   * "Add the set": adds all three stone forms in one action.
   *
   * The ids come from a data attribute written by Liquid at render time, so
   * nothing here knows which variants are stone. The add itself is handed to
   * the cart drawer module — this class owns the button states and nothing
   * about carts.
   */
  class StoneSet {
    constructor(root) {
      this.buttons = [...root.querySelectorAll('[data-stone-set]')];
      if (!this.buttons.length) return;

      this.root = root;
      this.submits = [...root.querySelectorAll('[data-product-submit]')];
      this.errors = [...root.querySelectorAll('[data-set-error]')];
      this.labels = [...root.querySelectorAll('[data-stone-set-text]')];

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.add(button));
      });
    }

    showError(message) {
      this.errors.forEach((node) => {
        node.textContent = message || '';
        node.hidden = !message;
      });
    }

    /*
     * Disabling records what each button's state already was and restores
     * that, rather than enabling everything on the way out — the add button
     * is legitimately disabled when the selected variant is sold out, and
     * blanket re-enabling would quietly make it clickable again.
     */
    setBusy(busy) {
      if (busy) {
        this.previous = [...this.submits, ...this.buttons].map((b) => b.disabled);
        [...this.submits, ...this.buttons].forEach((b) => {
          b.disabled = true;
        });
      } else {
        [...this.submits, ...this.buttons].forEach((b, i) => {
          b.disabled = this.previous ? this.previous[i] : false;
        });
      }

      const label = busy ? this.root.dataset.setAddingLabel : this.root.dataset.setLabel;
      this.labels.forEach((node) => {
        node.textContent = label;
      });
    }

    async add(button) {
      const ids = (button.dataset.stoneSet || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);
      if (!ids.length) return;

      const drawer = window.cartDrawer;
      if (!drawer || typeof drawer.addItems !== 'function') {
        this.showError(this.root.dataset.setErrorLabel);
        return;
      }

      this.showError('');
      this.setBusy(true);

      try {
        await drawer.addItems(ids.map((id) => ({ id: Number(id), quantity: 1 })));
      } catch (error) {
        // The drawer is deliberately not opened on failure.
        this.showError(this.root.dataset.setErrorLabel);
      } finally {
        this.setBusy(false);
      }
    }
  }

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    new ProductVariants(root);
    new ProductStickyBar(root);
    new StoneSet(root);
  });

  } catch(e) { console.error(e); }
})();
})();
